export const CLUB_APPLICATION_LOADING = "CLUB_APPLICATION_LOADING";
export const GET_CLUB_APPLICATIONS = "GET_CLUB_APPLICATIONS";
export const SET_CLUB_APPLICATION = "SET_CLUB_APPLICATION"